import React from 'react';

const HeroSection = () => {
  return (
    <section id="inicio" className="hero-section">
      <div className="hero-inner">
        <div className="hero-content fade-in-up">
          <h1>
            {"Soluções digitais sob medida para o "}
            <span>futuro</span>
            {" da sua empresa."}
          </h1>
          <p>
            {"Desenvolvemos sistemas ERP, WMS e aplicações completas que impulsionam a eficiência operacional e o crescimento sustentável do seu negócio."}
          </p>
          <div className="hero-buttons">
            <a href="#recursos" className="btn-primary-custom">
              {"Nossos Serviços"}
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M3.33 8h9.34M8.67 4l4 4-4 4"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </a>
            <a href="#contato" className="btn-outline-custom">
              Fale Conosco
            </a>
          </div>
        </div>

        <div className="hero-visual fade-in-up" style={{ animationDelay: '0.2s' }}>
          <video
            autoPlay
            muted
            loop
            playsInline
            style={{ aspectRatio: '4/3' }}
          >
            <source src="/videos/devs.mp4" type="video/mp4" />
            {"Seu navegador não suporta o elemento de vídeo."}
          </video>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
